/**
 * Toggle the context drawer open/closed and select the given page.
 *
 * @param {string} page The drawer page name to display.
 */
function drawerToggle(page) {
	$('#display-content').toggleClass('drawer_open');
	selectPage(page);
}
/**
 * Open the context drawer and select the given page.
 *
 * @param {string} page The drawer page name to display.
 */
function drawerOpen(page) {
	$('#display-content').addClass('drawer_open');
	selectPage(page);
}

/**
 * Close the context drawer.
 */
function drawerClose() {
	$('#display-content').removeClass('drawer_open');
	selectPage();
}

/**
 * Select and display a specific drawer page.
 *
 * @param {string} page The drawer page name to display (empty to deselect all).
 */
function selectPage(page = '') {
	$('#context-drawer .drawer-page').removeClass('selected');
	if ($('#display-content').hasClass('drawer_open')) {
		$('#context-drawer .drawer-page[data-page="'+page+'"]').addClass('selected');
	}
}

/**
 * Toggle the processing state of the context drawer.
 *
 * When active, pointer events are disabled and a loading overlay
 * is displayed to prevent user interaction during AJAX requests.
 *
 * @param {boolean} state - True to enable processing, false to disable.
 */
function setDrawerProcessing(state) {
	$('#context-drawer').toggleClass('processing', state);
}